import * as api from '@/api/booking'
import Booking from '@/store/models/booking'

export let state = {
  booking: new Booking,
  bookings: {
    data: []
  }
}

export let mutations = {
  setBookings: (state, payload) => state.bookings = payload,

  reset: state => state.booking = new Booking,
  setBooking: (state, payload) => state.booking = (new Booking).hydrate(payload),
}

export let actions = {

  paginateBookings: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginateBookings(path, response => {
      commit('setBookings', response.data)
      resolve()
    }, reject)
  }),

  load: ({ commit }, booking) => new Promise((resolve, reject) => {
    api.load(booking, response => {
      commit('setBooking', response.data)
      resolve()
    }, reject)
  }),

  approve: ({ state }) => new Promise((resolve, reject) => {
    api.approve(state.booking, () => {
      resolve()
    }, reject)
  }),

  reject: ({ state }) => new Promise((resolve, reject) => {
    api.reject(state.booking, () => {
      resolve()
    }, reject)
  }),

  remind: ({ state }) => new Promise((resolve, reject) => {
    api.remind(state.booking, () => {
      resolve()
    }, reject)
  }),

  downloadInvoice: ({ state }) => new Promise((resolve, reject) => {
    api.downloadInvoice(state.booking, response => {
      resolve(response.data)
    }, reject)
  }),

  removeSlot: ({ state }, slot) => new Promise((resolve, reject) => {
    api.removeSlot(state.booking, slot, () => {
      resolve()
    }, reject)
  }),

  assignAdditionalBilling: ({ state }, items) => new Promise((resolve, reject) => {
    api.assignAdditionalBilling(state.booking, items, () => {
      resolve()
    }, reject)
  }),

  downloadAddBillingInvoice: ({ state }) => new Promise((resolve, reject) => {
    api.downloadAddBillingInvoice(state.booking, response => {
      resolve(response.data)
    }, reject)
  }),

  remindAddBilling: ({ state }) => new Promise((resolve, reject) => {
    api.remindAddBilling(state.booking, () => {
      resolve()
    }, reject)
  }),

  deleteDeposit: ({ state }, deposit) => new Promise((resolve, reject) => {
    api.deleteDeposit({ booking: state.booking.id, deposit: deposit.id }, resolve, reject)
  }),
}
